export default __webpack_public_path__ + "static/media/Snd_TryR.52ef72cf.mp3";